document.addEventListener('DOMContentLoaded', function() {
  function addClassOnInView(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view'); // Add class when the element is in view
      } else {
        entry.target.classList.remove('in-view');
      }
    });
  }
  
  let observer = new IntersectionObserver(addClassOnInView, {
    threshold: 0.5
  });
  
  let items = document.querySelectorAll('svg.mountains');
  
  items.forEach(item => {
    observer.observe(item);
  });

})

